import React from 'react';
import { Card } from '../components/ui/Card';
import { HomeIcon, SearchIcon, PlusIcon, FilterIcon, UserIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
export const HostelManagement = () => {
  return <div className="space-y-6" data-id="element-796">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between" data-id="element-797">
        <div data-id="element-798">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-799">
            Hostel Management
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-800">
            Manage hostel allocation and room assignments
          </p>
        </div>
        <div className="mt-4 sm:mt-0" data-id="element-801">
          <button className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-802">
            <PlusIcon size={18} className="mr-1" data-id="element-803" />
            <span data-id="element-804">New Allocation</span>
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-805">
        <Card title="Boys Hostel Occupancy" data-id="element-806">
          <div className="flex items-center justify-center py-4" data-id="element-807">
            <div className="w-full max-w-xs" data-id="element-808">
              <div className="relative pt-1" data-id="element-809">
                <div className="flex mb-2 items-center justify-between" data-id="element-810">
                  <div data-id="element-811">
                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blue-600 bg-blue-200" data-id="element-812">
                      Block A
                    </span>
                  </div>
                  <div className="text-right" data-id="element-813">
                    <span className="text-xs font-semibold inline-block text-blue-600" data-id="element-814">
                      98%
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-blue-200" data-id="element-815">
                  <div style={{
                  width: '98%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-600" data-id="element-816"></div>
                </div>
              </div>
              <div className="relative pt-1" data-id="element-817">
                <div className="flex mb-2 items-center justify-between" data-id="element-818">
                  <div data-id="element-819">
                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blue-600 bg-blue-200" data-id="element-820">
                      Block B
                    </span>
                  </div>
                  <div className="text-right" data-id="element-821">
                    <span className="text-xs font-semibold inline-block text-blue-600" data-id="element-822">
                      92%
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-blue-200" data-id="element-823">
                  <div style={{
                  width: '92%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-600" data-id="element-824"></div>
                </div>
              </div>
              <div className="relative pt-1" data-id="element-825">
                <div className="flex mb-2 items-center justify-between" data-id="element-826">
                  <div data-id="element-827">
                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-blue-600 bg-blue-200" data-id="element-828">
                      Block C
                    </span>
                  </div>
                  <div className="text-right" data-id="element-829">
                    <span className="text-xs font-semibold inline-block text-blue-600" data-id="element-830">
                      86%
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-blue-200" data-id="element-831">
                  <div style={{
                  width: '86%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-600" data-id="element-832"></div>
                </div>
              </div>
              <div className="mt-4 text-center" data-id="element-833">
                <p className="text-sm text-gray-600" data-id="element-834">
                  Total Capacity: <span className="font-medium" data-id="element-835">500</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-836">
                  Currently Occupied: <span className="font-medium" data-id="element-837">470</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-838">
                  Available Rooms: <span className="font-medium" data-id="element-839">30</span>
                </p>
              </div>
            </div>
          </div>
        </Card>
        <Card title="Girls Hostel Occupancy" data-id="element-840">
          <div className="flex items-center justify-center py-4" data-id="element-841">
            <div className="w-full max-w-xs" data-id="element-842">
              <div className="relative pt-1" data-id="element-843">
                <div className="flex mb-2 items-center justify-between" data-id="element-844">
                  <div data-id="element-845">
                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-purple-600 bg-purple-200" data-id="element-846">
                      Block A
                    </span>
                  </div>
                  <div className="text-right" data-id="element-847">
                    <span className="text-xs font-semibold inline-block text-purple-600" data-id="element-848">
                      88%
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-purple-200" data-id="element-849">
                  <div style={{
                  width: '88%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-purple-600" data-id="element-850"></div>
                </div>
              </div>
              <div className="relative pt-1" data-id="element-851">
                <div className="flex mb-2 items-center justify-between" data-id="element-852">
                  <div data-id="element-853">
                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-purple-600 bg-purple-200" data-id="element-854">
                      Block B
                    </span>
                  </div>
                  <div className="text-right" data-id="element-855">
                    <span className="text-xs font-semibold inline-block text-purple-600" data-id="element-856">
                      76%
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-purple-200" data-id="element-857">
                  <div style={{
                  width: '76%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-purple-600" data-id="element-858"></div>
                </div>
              </div>
              <div className="relative pt-1" data-id="element-859">
                <div className="flex mb-2 items-center justify-between" data-id="element-860">
                  <div data-id="element-861">
                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-purple-600 bg-purple-200" data-id="element-862">
                      Block C
                    </span>
                  </div>
                  <div className="text-right" data-id="element-863">
                    <span className="text-xs font-semibold inline-block text-purple-600" data-id="element-864">
                      72%
                    </span>
                  </div>
                </div>
                <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-purple-200" data-id="element-865">
                  <div style={{
                  width: '72%'
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-purple-600" data-id="element-866"></div>
                </div>
              </div>
              <div className="mt-4 text-center" data-id="element-867">
                <p className="text-sm text-gray-600" data-id="element-868">
                  Total Capacity: <span className="font-medium" data-id="element-869">400</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-870">
                  Currently Occupied: <span className="font-medium" data-id="element-871">312</span>
                </p>
                <p className="text-sm text-gray-600" data-id="element-872">
                  Available Rooms: <span className="font-medium" data-id="element-873">88</span>
                </p>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <Card data-id="element-874">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between pb-4 border-b border-gray-200" data-id="element-875">
          <div className="relative" data-id="element-876">
            <span className="absolute inset-y-0 left-0 flex items-center pl-3" data-id="element-877">
              <SearchIcon size={18} className="text-gray-400" data-id="element-878" />
            </span>
            <input type="text" placeholder="Search by student name or room..." className="pl-10 pr-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 w-full sm:w-64" data-id="element-879" />
          </div>
          <div className="mt-3 sm:mt-0 flex space-x-2" data-id="element-880">
            <button className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center" data-id="element-881">
              <FilterIcon size={16} className="mr-1" data-id="element-882" />
              <span data-id="element-883">Filters</span>
            </button>
            <select className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" data-id="element-884">
              <option value="" data-id="element-885">All Blocks</option>
              <option value="boys-a" data-id="element-886">Boys - Block A</option>
              <option value="boys-b" data-id="element-887">Boys - Block B</option>
              <option value="boys-c" data-id="element-888">Boys - Block C</option>
              <option value="girls-a" data-id="element-889">Girls - Block A</option>
              <option value="girls-b" data-id="element-890">Girls - Block B</option>
              <option value="girls-c" data-id="element-891">Girls - Block C</option>
            </select>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-892">
          <table className="min-w-full divide-y divide-gray-200 mt-4" data-id="element-893">
            <thead className="bg-gray-50" data-id="element-894">
              <tr data-id="element-895">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-896">
                  Student
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-897">
                  Hostel
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-898">
                  Room No.
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-899">
                  Allocated On
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-900">
                  Status
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-901">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-902">
              {[{
              name: 'Rahul Sharma',
              id: 'ST2023001',
              hostel: 'Boys Hostel',
              block: 'Block A',
              room: 'A-112',
              date: 'Jul 15, 2023',
              status: 'Occupied'
            }, {
              name: 'Amit Kumar',
              id: 'ST2023022',
              hostel: 'Boys Hostel',
              block: 'Block B',
              room: 'B-204',
              date: 'Jul 16, 2023',
              status: 'Occupied'
            }, {
              name: 'Vikram Joshi',
              id: 'ST2023041',
              hostel: 'Boys Hostel',
              block: 'Block C',
              room: 'C-305',
              date: 'Jul 18, 2023',
              status: 'Occupied'
            }, {
              name: 'Rajesh Khanna',
              id: 'ST2023052',
              hostel: 'Boys Hostel',
              block: 'Block A',
              room: 'A-118',
              date: 'Jul 20, 2023',
              status: 'Vacating'
            }, {
              name: 'Priya Patel',
              id: 'ST2023014',
              hostel: 'Girls Hostel',
              block: 'Block A',
              room: 'A-212',
              date: 'Jul 15, 2023',
              status: 'Occupied'
            }, {
              name: 'Neha Singh',
              id: 'ST2023035',
              hostel: 'Girls Hostel',
              block: 'Block B',
              room: 'B-104',
              date: 'Jul 17, 2023',
              status: 'Occupied'
            }, {
              name: 'Anjali Desai',
              id: 'ST2023048',
              hostel: 'Girls Hostel',
              block: 'Block C',
              room: 'C-205',
              date: 'Jul 19, 2023',
              status: 'Occupied'
            }, {
              name: 'Sonia Gupta',
              id: 'ST2023067',
              hostel: 'Girls Hostel',
              block: 'Block A',
              room: 'A-218',
              date: 'Jul 21, 2023',
              status: 'Vacant'
            }].map((allocation, index) => <tr key={index} data-id="element-903">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-904">
                    <div className="flex items-center" data-id="element-905">
                      <div className="flex-shrink-0 h-8 w-8 bg-indigo-100 rounded-full flex items-center justify-center" data-id="element-906">
                        <span className="text-xs font-medium text-indigo-800" data-id="element-907">
                          {allocation.name.split(' ').map(n => n[0]).join('')}
                        </span>
                      </div>
                      <div className="ml-4" data-id="element-908">
                        <div className="text-sm font-medium text-gray-900" data-id="element-909">
                          {allocation.name}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-910">
                          {allocation.id}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-911">
                    <div data-id="element-912">{allocation.hostel}</div>
                    <div className="text-xs text-gray-400" data-id="element-913">
                      {allocation.block}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium" data-id="element-914">
                    {allocation.room}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-915">
                    {allocation.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-916">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${allocation.status === 'Occupied' ? 'bg-green-100 text-green-800' : allocation.status === 'Vacant' ? 'bg-gray-100 text-gray-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-917">
                      {allocation.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-918">
                    <a href="#" className="text-indigo-600 hover:text-indigo-900 mr-3" data-id="element-919">
                      View
                    </a>
                    <a href="#" className="text-indigo-600 hover:text-indigo-900" data-id="element-920">
                      Edit
                    </a>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="flex items-center justify-between border-t border-gray-200 px-4 py-3 sm:px-6 mt-4" data-id="element-921">
          <div className="flex flex-1 justify-between sm:hidden" data-id="element-922">
            <a href="#" className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-923">
              Previous
            </a>
            <a href="#" className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50" data-id="element-924">
              Next
            </a>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-925">
            <div data-id="element-926">
              <p className="text-sm text-gray-700" data-id="element-927">
                Showing <span className="font-medium" data-id="element-928">1</span> to{' '}
                <span className="font-medium" data-id="element-929">8</span> of{' '}
                <span className="font-medium" data-id="element-930">48</span> results
              </p>
            </div>
            <div data-id="element-931">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-932">
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-933">
                  <span className="sr-only" data-id="element-934">Previous</span>
                  <span data-id="element-935">«</span>
                </a>
                <a href="#" aria-current="page" className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-936">
                  1
                </a>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-937">
                  2
                </a>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-938">
                  3
                </a>
                <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700" data-id="element-939">
                  ...
                </span>
                <a href="#" className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium" data-id="element-940">
                  6
                </a>
                <a href="#" className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-941">
                  <span className="sr-only" data-id="element-942">Next</span>
                  <span data-id="element-943">»</span>
                </a>
              </nav>
            </div>
          </div>
        </div>
      </Card>
    </div>;
};